import { render, staticRenderFns } from "./assignItem.vue?vue&type=template&id=0f21df4a&"
import script from "./assignItem.vue?vue&type=script&lang=js&"
export * from "./assignItem.vue?vue&type=script&lang=js&"
import style0 from "./assignItem.vue?vue&type=style&index=0&id=0f21df4a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports